/* Selector Región / Comuna (Chile) para el carrito — United Rest.
 * Adaptado desde DEV EIGHT (Horizon) al tema de urest.cl.
 * Guarda la selección como atributos del carrito y la envía al checkout
 * (checkout[shipping_address][province] / [city]). */
(function () {
  if (window.__clRegionComuna) return;
  window.__clRegionComuna = true;

  var DATA = [{"c":"AP","n":"Arica y Parinacota","k":["Arica","Camarones","General Lagos","Putre"]},{"c":"TA","n":"Tarapacá","k":["Alto Hospicio","Camiña","Colchane","Huara","Iquique","Pica","Pozo Almonte"]},{"c":"AN","n":"Antofagasta","k":["Antofagasta","Calama","María Elena","Mejillones","Ollagüe","San Pedro de Atacama","Sierra Gorda","Taltal","Tocopilla"]},{"c":"AT","n":"Atacama","k":["Alto del Carmen","Caldera","Chañaral","Copiapó","Diego de Almagro","Freirina","Huasco","Tierra Amarilla","Vallenar"]},{"c":"CO","n":"Coquimbo","k":["Andacollo","Canela","Combarbalá","Coquimbo","Illapel","La Higuera","La Serena","Los Vilos","Monte Patria","Ovalle","Paiguano","Punitaqui","Río Hurtado","Salamanca","Vicuña"]},{"c":"VS","n":"Valparaíso","k":["Algarrobo","Cabildo","Calle Larga","Cartagena","Casablanca","Catemu","Concón","El Quisco","El Tabo","Hijuelas","Isla de Pascua","Juan Fernández","La Calera","La Cruz","La Ligua","Limache","Llaillay","Los Andes","Nogales","Olmué","Panquehue","Papudo","Petorca","Puchuncaví","Putaendo","Quillota","Quilpué","Quintero","Rinconada","San Antonio","San Esteban","San Felipe","Santa María","Santo Domingo","Valparaíso","Villa Alemana","Viña del Mar","Zapallar"]},{"c":"RM","n":"Región Metropolitana","k":["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Ñuñoa","Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago","Talagante","Tiltil","Vitacura"]},{"c":"LI","n":"O'Higgins","k":["Chépica","Chimbarongo","Codegua","Coínco","Coltauco","Doñihue","Graneros","La Estrella","Las Cabras","Litueche","Lolol","Machalí","Malloa","Marchigüe","Nancagua","Navidad","Olivar","Palmilla","Paredones","Peralillo","Peumo","Pichidegua","Pichilemu","Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requínoa","San Fernando","San Francisco de Mostazal","San Vicente","Santa Cruz"]},{"c":"ML","n":"Maule","k":["Cauquenes","Chanco","Colbún","Constitución","Curepto","Curicó","Empedrado","Hualañé","Licantén","Linares","Longaví","Maule","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Río Claro","Romeral","Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquén","Villa Alegre","Yerbas Buenas"]},{"c":"NB","n":"Ñuble","k":["Bulnes","Chillán","Chillán Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue","Ñiquén","Pemuco","Pinto","Portezuelo","Quillón","Quirihue","Ránquil","San Carlos","San Fabián","San Ignacio","San Nicolás","Trehuaco","Yungay"]},{"c":"BI","n":"Biobío","k":["Alto Biobío","Antuco","Arauco","Cabrero","Cañete","Chiguayante","Concepción","Contulmo","Coronel","Curanilahue","Florida","Hualpén","Hualqui","Laja","Lebu","Los Álamos","Los Ángeles","Lota","Mulchén","Nacimiento","Negrete","Penco","Quilaco","Quilleco","San Pedro de la Paz","San Rosendo","Santa Bárbara","Santa Juana","Talcahuano","Tirúa","Tomé","Tucapel","Yumbel"]},{"c":"AR","n":"La Araucanía","k":["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautín","Curarrehue","Ercilla","Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco","Melipeuco","Nueva Imperial","Padre Las Casas","Perquenco","Pitrufquén","Pucón","Purén","Renaico","Saavedra","Temuco","Teodoro Schmidt","Toltén","Traiguén","Victoria","Vilcún","Villarrica"]},{"c":"LR","n":"Los Ríos","k":["Corral","Futrono","La Unión","Lago Ranco","Lanco","Los Lagos","Máfil","Mariquina","Paillaco","Panguipulli","Río Bueno","Valdivia"]},{"c":"LL","n":"Los Lagos","k":["Ancud","Calbuco","Castro","Chaitén","Chonchi","Cochamó","Curaco de Vélez","Dalcahue","Fresia","Frutillar","Futaleufú","Hualaihué","Llanquihue","Los Muermos","Maullín","Osorno","Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldón","Purranque","Puyehue","Queilén","Quellón","Quemchi","Quinchao","Río Negro","San Juan de la Costa","San Pablo"]},{"c":"AI","n":"Aysén","k":["Aysén","Chile Chico","Cisnes","Cochrane","Coyhaique","Guaitecas","Lago Verde","O'Higgins","Río Ibáñez","Tortel"]},{"c":"MA","n":"Magallanes","k":["Antártica","Cabo de Hornos","Laguna Blanca","Natales","Porvenir","Primavera","Punta Arenas","Río Verde","San Gregorio","Timaukel","Torres del Paine"]}];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = null; // { code, region, comuna }
  var saveQueue = Promise.resolve();

  function byCode(code) {
    for (var i = 0; i < DATA.length; i++) if (DATA[i].c === code) return DATA[i];
    return null;
  }
  function byName(name) {
    for (var i = 0; i < DATA.length; i++) if (DATA[i].n === name) return DATA[i];
    return null;
  }
  function opt(value, label, selected) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    if (selected) o.selected = true;
    return o;
  }

  // Guarda en serie para que una respuesta antigua no pise la selección más reciente
  function saveAttributes() {
    saveQueue = saveQueue.then(function () {
      var attrs = {
        'Región': state && state.region ? state.region : '',
        'Comuna': state && state.comuna ? state.comuna : ''
      };
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    });
    return saveQueue;
  }

  class ClRegionComuna extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.regionSel = this.querySelector('[data-cl-region]');
      this.comunaSel = this.querySelector('[data-cl-comuna]');
      this.errorEl = this.querySelector('[data-cl-error]');
      if (!this.regionSel || !this.comunaSel) return;

      if (!state) {
        var r = byName(this.dataset.region || '');
        state = { code: r ? r.c : '', region: r ? r.n : '', comuna: r ? this.dataset.comuna || '' : '' };
      }

      this.regionSel.innerHTML = '';
      this.regionSel.appendChild(opt('', 'Selecciona tu región', !state.code));
      for (var i = 0; i < DATA.length; i++) {
        this.regionSel.appendChild(opt(DATA[i].c, DATA[i].n, DATA[i].c === state.code));
      }
      this.fillComunas();

      var self = this;
      // stopPropagation: el carrito del tema escucha 'change' para actualizar cantidades
      this.regionSel.addEventListener('change', function (e) {
        e.stopPropagation();
        var r = byCode(self.regionSel.value);
        state = { code: r ? r.c : '', region: r ? r.n : '', comuna: '' };
        self.fillComunas();
        self.hideError();
        syncAll(self);
        saveAttributes();
      });
      this.comunaSel.addEventListener('change', function (e) {
        e.stopPropagation();
        state.comuna = self.comunaSel.value;
        self.hideError();
        syncAll(self);
        saveAttributes();
      });
    }

    fillComunas() {
      var r = byCode(state.code);
      this.comunaSel.innerHTML = '';
      this.comunaSel.appendChild(opt('', r ? 'Selecciona tu comuna' : 'Primero elige una región', !state.comuna));
      if (r) {
        for (var i = 0; i < r.k.length; i++) {
          this.comunaSel.appendChild(opt(r.k[i], r.k[i], r.k[i] === state.comuna));
        }
      }
      this.comunaSel.disabled = !r;
    }

    sync() {
      this.regionSel.value = state.code || '';
      this.fillComunas();
    }

    showError() {
      if (this.errorEl) this.errorEl.hidden = false;
      (state && state.code ? this.comunaSel : this.regionSel).focus();
    }
    hideError() {
      if (this.errorEl) this.errorEl.hidden = true;
    }
  }

  function syncAll(except) {
    document.querySelectorAll('cl-region-comuna').forEach(function (el) {
      if (el !== except && el._ready && el.regionSel) el.sync();
    });
  }

  if (!customElements.get('cl-region-comuna')) {
    customElements.define('cl-region-comuna', ClRegionComuna);
  }

  // Selector más cercano al botón: el del drawer o el de la página de carrito
  function visibleSelector(button) {
    var scope = button.closest('cart-drawer, .cart__summary, form') || document;
    return scope.querySelector('cl-region-comuna') || document.querySelector('cl-region-comuna');
  }

  function checkoutUrl() {
    var p = new URLSearchParams();
    p.set('checkout[shipping_address][country]', 'CL');
    p.set('checkout[shipping_address][province]', state.code);
    p.set('checkout[shipping_address][city]', state.comuna);
    return ROOT + 'checkout?' + p.toString();
  }

  function handleCheckout(event, button) {
    var selector = visibleSelector(button);
    if (!selector) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!state || !state.code || !state.comuna) {
      selector.showError();
      return;
    }
    // Respeta el checkbox de términos y condiciones del tema (u otros campos requeridos)
    var form = button.form || button.closest('form');
    if (form && !form.checkValidity()) {
      form.reportValidity();
      return;
    }
    button.setAttribute('aria-busy', 'true');
    Promise.resolve(saveAttributes()).then(function () {
      window.location.href = checkoutUrl();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');
      if (button && !button.disabled) handleCheckout(event, button);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') handleCheckout(event, submitter);
    },
    true
  );
})();
